import { SAVE_FORM_OFFER_VALUES, BANKS_RECEIVED, TYPE_PHONE_REQUIRED } from "../shared/constants";

const initialCreateOfferState = {
	form: [],
	typePhoneLatam: 9
};

export const createOffer = (state = initialCreateOfferState, action) => {
	switch (action.type) {
		case SAVE_FORM_OFFER_VALUES:
			return {
				...state,
				form: action.form
			};
		case BANKS_RECEIVED:
			return {
				...state,
				banks: action.banks
			};
		case TYPE_PHONE_REQUIRED:
			return {
				...state,
				typePhoneLatam: action.typePhoneLatam
			};

		default:
			return state;
	}
};
